import styled from 'styled-components';
  
export const Button = styled.div`
   position: fixed; 
   width: 100%;
   left: 10%;
   bottom: 40px;
   height: 150px;
   font-size: 3rem;
   z-index: 1;
   cursor: pointer;
   color: lightGreen;
`